import React, { useEffect } from 'react'
import success from '../../assets/student_registration/greentick.png'
import { useLocation } from "react-router-dom";
function Registration_Success() {
    const location = useLocation();
    const txnId = location.state.txnId;
    const amount = location.state.amount;

    useEffect(()=>{

        const timer = setTimeout(()=>{
            window.location.href='https://aspireitacademy.in/';
        },30000)

        return () => clearTimeout(timer);
    },[]);


  return (
    <section>
        <div className="payment-success-container d-flex justify-content-center align-items-center vh-100">
            <div className="payment-success-card p-3 p-sm-5 text-center" >
                    <img src={success} alt="success"  width="100px" height="100px" className='mb-3'/>
                    <h3 style={{color:'#218321'}} className='mb-4'>Registration Successful!</h3>
                    <hr className='my-5' style={{borderTop: '3px dashed red'}}/>
                    <div className="content mb-3 px-0 px-sm-5">
                        <div className='d-flex justify-content-between my-3'>
                            <span className='payment-success-text'>Transaction ID:</span>
                            <span  className='payment-success-text'>{txnId}</span>
                        </div>
                        <div className='d-flex justify-content-between'>
                            <span  className='payment-success-text'>Registration Fee:</span>
                            <span  className='payment-success-text'>&#8377; {amount} </span>
                        </div>
                    </div>
            </div>
        </div>
    </section>
  )
}

export default Registration_Success